// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form__container[data-v-1f59b3b9]{max-width:-moz-max-content;max-width:max-content}.form__checkbox[data-v-1f59b3b9]  .v-messages{display:none}.form__checkbox[data-v-1f59b3b9]  .v-input__slot{margin-bottom:0}.form__checkbox[data-v-1f59b3b9]  .v-input--selection-controls__input{align-self:flex-start}.form__checkbox[data-v-1f59b3b9]  .v-label{top:1px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
